import { useMemo } from 'react';

import { useAuth } from '@klpkonsern/auth-core';
import { useAppParams } from '@klp/core/app/useAppParams';

import type { User } from '../packages/user/classes/User';
import { useGetCurrentUserQuery } from '../packages/user/services/rtkApi';

export const useCurrentUser = () => {
    const { authenticatedOidcUser, isAuthenticatedOidcUser, hasRole } =
        useAuth();
    const isAdmin = hasRole('admin');
    const appParams = useAppParams();

    appParams.isAdmin = isAdmin;

    const { data: userData, isLoading: currentUserIsLoading } =
        useGetCurrentUserQuery(
            { isAdmin },
            {
                skip: !isAuthenticatedOidcUser,
            },
        );

    const currentUser = useMemo(() => {
        if (!isAuthenticatedOidcUser || !authenticatedOidcUser || !userData) {
            return undefined;
        }
        // Create a new User instance with admin flags
        const user = Object.assign({}, userData, { isAdmin });

        return user as User;
    }, [isAuthenticatedOidcUser, authenticatedOidcUser, userData, isAdmin]);

    return {
        isAuthenticated: isAuthenticatedOidcUser,
        currentUser,
        currentUserIsLoading,
        isAdmin,
    };
};
